module.exports = __webpack_public_path__ + "static/media/healtheat.82d93e85.png";